import FormsType from '../Models/FormsType';
import DataGridRequest from './DataGridRequest';
export class FormsRequest extends DataGridRequest<FormsType> {
    Url = 'forms/home/api';
}
